// extracted by mini-css-extract-plugin
export default {"container":"Error_container__5B4N8","title":"Error_title__wvChf"};